
namespace TabAurous.Administration {

    @Serenity.Decorators.registerClass()
    export class ItemDiscountDetailsGrid extends Serenity.EntityGrid<ItemDiscountDetailsRow, any> {
        protected getColumnsKey() { return 'Administration.ItemDiscountDetails'; }
        protected getDialogType() { return ItemDiscountDetailsDialog; }
        protected getIdProperty() { return ItemDiscountDetailsRow.idProperty; }
        protected getInsertPermission() { return ItemDiscountDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return ItemDiscountDetailsRow.localTextPrefix; }
        protected getService() { return ItemDiscountDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}